// apps/website/src/App.tsx
//
// The marketing site keeps its own minimal shell: a router with three public
// routes and no authenticated app shell. The auth provider is mounted only
// because WaitList reads `isAuthenticated` to decide whether to show the
// "Join" call to action.
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./providers/AuthProvider";
import { WebLayout } from "./components/common/Layout/WebLayout";
import OverviewPage from "./pages/overview";
import TermsPage from "./pages/terms";
import PrivacyPage from "./pages/privacy";

function App() {
  return (
    <AuthProvider
      config={{
        enableCache: true,
        cacheTTL: 3600,
        enableMetrics: false,
        sessionRefreshInterval: 300000,
        maxRetries: 3,
      }}
      onError={(error) => {
        console.error("Auth error:", error);
      }}
    >
      <Router>
        <WebLayout>
          <Routes>
            <Route path="/" element={<OverviewPage />} />
            <Route path="/overview" element={<Navigate to="/" replace />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </WebLayout>
      </Router>
    </AuthProvider>
  );
}

export default App;
